import React from "react";
import "./NonBackGroundModal.scss";
import { Modal } from "react-bootstrap";

export default class NonBackGroundModal extends React.PureComponent<
    {
        attachmentId: string;
        showModal: boolean;
        onClose: any;
        hasVideo: boolean;
    },
    {}
> {
    transformWrapperRef: React.RefObject<any>;
    constructor(props: any) {
        super(props);
        this.state = {}
        this.transformWrapperRef = React.createRef();
    }

    close() {
        let { onClose } = this.props;

        this.transformWrapperRef.current?.resetTransform()
        onClose()
    }

    render(): React.ReactNode {
        let { showModal, attachmentId, hasVideo, onClose } = this.props;
        let url = `https://cdn.barandehsaz.com/FileUploader/Download/?AttachmentID=${attachmentId}`;

        let contents = (<></>);
        if (attachmentId != null)
            if (!hasVideo)
                contents = (
                    <img src={url} alt="question" className="full-width" />);
            else
                contents = (
                    <video style={{ width: "100%" }} height="185" controls autoPlay={true}>
                        <source src={url} type="video/mp4" />
                    </video>)

        return (
            <>
                <Modal show={showModal} onHide={onClose} animation={true}>
                    <Modal.Header >
                        <Modal.Title dir="rtl">
                            <div className="text-center">
                                نمایش
                            </div>
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <div style={{ textAlign: 'center' }}>
                            {
                                contents
                            }
                        </div>
                    </Modal.Body >
                    <Modal.Footer dir="ltr">
                        <button className="btn btn btn-primary tk-float-left" onClick={onClose}>بستن</button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}
